import type { SnackbarOrigin } from '@mui/material/Snackbar';
import { create } from 'zustand';

interface ISnackbarState extends Partial<SnackbarOrigin> {
    text: string;
    duration: number;
}

interface ISnackbarAction {
    show: (props: ISnackbarState) => void;
    hide: () => void;
}

const snackbar = create<ISnackbarState & ISnackbarAction>(set => ({
    text: '',
    duration: 0,
    horizontal: 'left',
    vertical: 'bottom',

    show: props => void set(() => props),
    hide: () => void set({ duration: 0 }),
}));

export function useSnackbarProps() {
    return snackbar();
}

export function useSnackbar() {
    const show = snackbar(props => props.show);
    const hide = snackbar(props => props.hide);

    return { show, hide };
}

export function setSnackbar(props: ISnackbarState) {
    snackbar.setState(props);
}
